import { createUrl } from './create-url';

const Domains = {
    audi: 'audibilforsakring.se',
    cupra: 'cuprabilforsakring.se',
    dacia: 'daciaforsakring.se',
    ford: 'fordforsakring.se',
    isuzu: 'isuzuforsakring.se',
    kia: 'kiabilforsakring.com',
    mercedes: 'mercedes-benzforsakring.se',
    mg: 'mgbilforsakring.se',
    nissan: 'nissanforsakring.se',
    polestar: 'polestarinsurance.se',
    porsche: 'porschebilforsakring.se',
    renault: 'renaultforsakring.se',
    rulla: 'rulla-vidare.se',
    saab: 'saabforsakring.se',
    seat: 'seatbilforsakring.se',
    skoda: 'skodabilforsakring.se',
    subaru: 'subaruforsakring.se',
    volkswagen: 'volkswagenbilforsakring.se',
    volkswagentransport: 'volkswagentransportbilarforsakring.se',
    volvia: 'volvia.se',
};

const isMobilityDomain = (url: string): boolean => {
    if (!url) return false;

    for (const value of Object.values(Domains)) {
        if (url.includes(value)) {
            return true;
        }
    }

    return false;
};

const isMobilityOpenPagesTest = (url: string): boolean => /\.(i|s|a)test\.bravi\.if\.eu/.test(url);

export const getMobilityMyPagesUrl = (url: string): string => {
    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;
    const href = page.href;
    const origin = page.origin;

    if (/\/(logga-in|utloggning|inte-kund|tekniskt-fel|404)/.test(href)) return '';

    if (/minasidor-for-(bmw|mini|opel)\.fordon\.if\.se/.test(hostname)) return origin;

    if (!/minasidor(-itest|-stest|-atest|)\.app\./.test(hostname)) return '';

    if (isMobilityDomain(hostname)) return origin;

    return '';
};

export const getMobilityOpenPagesUrl = (url: string): string => {
    if (getMobilityMyPagesUrl(url)) return '';

    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;
    const origin = page.origin;

    if (isMobilityOpenPagesTest(hostname) || isMobilityDomain(hostname)) return origin;

    return '';
};
